import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { withRouter } from "../../../App";
import { getLoggenInToken } from "../../../store/selectors/AuthSelectors";
import { getAllJobs, hireCandidate } from "../../../store/actions/Jobs/jobActions";
import { Badge, Button } from "react-bootstrap";
import { del, get } from "../../../services/api";

import swal from "sweetalert";
import Select from "react-select";
import { loginRequest } from "../../../authConfig";
import { useMsal } from "@azure/msal-react";

const CandidateRemove = ({
  token,
  candidates,
  selectedRequirement,
  setShowAssignCandidateModal,
}) => {
  const { instance, accounts } = useMsal();
  const [unselectedCandidates, setUnselectedCandidates] = useState([]);
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [candidateList, setCandidateList] = useState([]);
  const dispatch = useDispatch();

  const getCandidateName = (id, responseData = null) => {
    const list = responseData || candidateList;
    const match = list?.find((itm) => itm?.candidateId === id);
    if (match?.candidateDetails) {
      const details = match.candidateDetails;
      return `${details.firstName || ""} ${details.lastName || ""}`.trim() || "--";
    }
    const data = candidates?.filter((itm) => itm?._id === id);
    return data?.[0]?.firstName && data?.[0]?.lastName
      ? data?.[0]?.firstName + " " + data?.[0]?.lastName
      : "--";
  };

  useEffect(() => {
    if (selectedRequirement?._id) {
      getCandidateJobList();
    }
  }, [selectedRequirement]);

  const getCandidateJobList = async () => {
    const response = await get(
      "/api/job/candidate/job/" + selectedRequirement?._id,
      token
    );
    setCandidateList(response);
    const filteredDefault = response?.map((c) => {
      return { value: c?.candidateId, label: getCandidateName(c?.candidateId, response) };
    });
    setSelectedCandidates(filteredDefault);
    const filtered = candidates?.map((c) => {
      return { value: c?._id, label: c?.firstName };
    });
    setUnselectedCandidates(filtered || []);
  };

  const handleRemoveCandidate = async (candidateId) => {
    try {
      const candidate = candidateList.find((c) => c.candidateId === candidateId);

      if (candidate?.hasSubmittedTimesheet) {
        swal(
          "Cannot Remove",
          "This candidate has submitted a timesheet and cannot be removed.",
          "warning"
        );
        return;
      }
      
      const confirmation = await swal({
        title: "Are you sure?",
        text: "Once removed, this candidate cannot be undone.",
        icon: "warning",
        buttons: ["Cancel", "Remove"],
        dangerMode: true,
      });

      if (confirmation) {
        
        const updatedSelectedCandidates = selectedCandidates.filter(
          (candidate) => candidate.value !== candidateId
        );
        setSelectedCandidates(updatedSelectedCandidates);
        
        const selectedCandidateId = candidateList.filter(
          (candidate) => candidate.candidateId === candidateId
        );
        const payload = {
          candidates: selectedCandidateId,
        };
        if (accounts?.length > 0) {
          const accessToken = await instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0],
          });
          payload.accessToken = accessToken.accessToken
        }
        
        await del(
          `/api/job/job-candidate/${selectedRequirement?._id}/${candidateId}`,
          token,
          payload
        );
        swal("Success", "Candidate removed successfully.", "success");
        dispatch(getAllJobs(token));
      }
    } catch (error) {
      swal("Error", "Failed to remove candidate. Please try again.", "error");
    }
  };

  return (
    <div className="d-flex">
      {/* Unselected Candidates */}
      <div className="candidate-panel w-100">
        <h5>Assigned Candidates</h5>
        {selectedCandidates?.map((d) => (
          <div
            key={d.value}
            className="d-flex align-items-center mb-2 p-2 border rounded"
          >
            <Badge bg="info" className="me-2">
              {d?.label}
            </Badge>
            <Button
              variant="outline-danger"
              size="sm"
              className="ms-auto rounded-pill"
              onClick={() => handleRemoveCandidate(d.value)}
            >
              <i className="bi bi-x-circle"></i> Remove
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    token: getLoggenInToken(state),
    candidates: state.candidates.candidates || [],
  };
};

export default withRouter(connect(mapStateToProps)(CandidateRemove));
